<template>
  <v-menu
    v-model="isDatePickerVisible"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ attrs, on }">
      <v-text-field
        v-model="formattedDate"
        append-icon="mdi-calendar"
        :rules="validationRules"
        v-bind="{ ...$attrs, ...attrs }"
        v-on="on"
        @change="_ => normalizeFormattedDate()"
        @focus="_ => onInputFocus()"
        @keydown.tab="_ => onInputTab()"
      />
    </template>
    <v-date-picker
      v-model="lazyDate"
      @change="_ => onDateSelected()"
    />
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateField',
  inheritAttrs: false,

  props: {
    rules: {
      type: Array,
      default: _ => [],
    },

    value: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      formattedDate: '',
      isDatePickerVisible: false,
      lazyDate: null,
      validationRules: [
        ...this.rules,
        v => moment(v, 'MM/DD/YYYY').isValid() || 'Invalid date',
      ],
    }
  },

  watch: {
    value: {
      handler (val) {
        const newDate = moment(val)

        if (newDate.isValid()) {
          this.lazyDate = newDate.format('YYYY-MM-DD')
          this.updateFormattedDate()
        } else {
          this.lazyDate = null
          this.formattedDate = val
        }
      },

      immediate: true,
    },
  },

  methods: {
    normalizeFormattedDate () {
      if (!this.formattedDate) return

      const regex = /^([0-9]{1,2})[^0-9]{0,1}([0-9]{1,2})[^0-9]{0,1}([0-9]{2,4})$/
      const digits = this.formattedDate.match(regex)?.slice(1)?.join('/')
      const date = moment(digits, 'MM/DD/YYYY')

      if (date.isValid()) this.formattedDate = date.format('L')
      this.updateDateValue()
    },

    onDateSelected () {
      this.isDatePickerVisible = false
      this.updateFormattedDate()
    },

    onInputFocus (e) {
      setTimeout(_ => { this.isDatePickerVisible = true }, 100)
    },

    onInputTab () {
      this.isDatePickerVisible = false
      this.normalizeFormattedDate()
    },

    updateDateValue () {
      const date = moment(this.formattedDate, 'L')
      if (date.isValid()) {
        this.lazyDate = date.format('YYYY-MM-DD')
        this.$emit('input', this.lazyDate)
      } else {
        this.$emit('input', '')
      }
    },

    updateFormattedDate () {
      const date = moment(this.lazyDate)

      if (date.isValid()) {
        this.formattedDate = date.format('L')
      } else {
        this.formattedDate = this.lazyDate || ''
        this.lazyDate = null
      }

      this.$emit('input', this.lazyDate)
    },
  },
}
</script>
